@let change = changeSg();
<i
  [atnDsTooltip]="change.tooltip"
  [class]="{
    'atn-icon': true,
    default: true,
    'atn-green': change.quality === QualityEnum.Good,
    'atn-yellow': change.quality === QualityEnum.Neutral,
    'atn-red': change.quality === QualityEnum.Bad,
    'atn-arrow-up': change.direction === DirectionEnum.Increase,
    'atn-arrow-right': change.direction === DirectionEnum.Steady,
    'atn-arrow-down': change.direction === DirectionEnum.Decrease,
  }"
></i>
